export default {
  'register.alert.confirm': 'Please check to agree to the terms of use',
  'register.alert.register_fail': 'Registration failed, please try again',
  'register.alert.phone_number.exists':
    'This phone number is already in use, please enter another one.',
  'register.alert.phone_number.verify_fail': 'Phone number verification failed, please re-enter',
  'register.alert.email.exists': 'This email is already in use, please enter another one.',
  'register.alert.email.verify_fail': 'Email verification failed, please re-enter',
  'register.alert.birthday.verify_fail': 'Birthday verification failed, please re-enter',
  'register.alert.gender.verify_fail': 'Gender verification failed, please re-enter',
  'register.alert.city.verify_fail': 'City verification failed, please re-enter',
  'register.alert.job.verify_fail': 'Job verification failed, please re-enter',
  'register.alert.education_level.verify_fail':
    'Education level verification failed, please re-enter',
  'register.alert.marriage.verify_fail': 'Marital status verification failed, please re-enter',
  'register.alert.interest.verify_fail': 'Interest verification failed, please re-enter',
  'register.alert.diet.verify_fail': 'Diet preference verification failed, please re-enter',
  'register.alert.line_account.registered': 'This LINE account has already been registered.',
  'register.alert.otp.verify_fail': 'OTP verification failed, please try again.',
  'register.alert.field_required': 'Some fields are not filled out completely, please try again.',
  'register.alert.referral_code': 'The referral code you entered is incorrect. Please check!',
  'register.alert.please_select': 'Please select',
  'register.alert.number_required': 'Please enter a number',
  'register.alert.number_length': 'Maximum of 18 digits, please re-enter',
  'register.phone_number': 'Phone number',
  'register.phone_number.required': 'Please enter a phone number',
  'register.phone_number.format_error': 'Incorrect phone number format',
  'register.phone_number.not_match': 'The phone numbers do not match',
  'register.phone_number.enter_again': 'Please re-enter the phone number',
  'register.name': 'Name',
  'register.name.required': 'Please enter your name',
  'register.name.format_error': 'Only English letters and Chinese characters are allowed',
  'register.birth': 'Birthday',
  'register.birth.required': 'Please enter your birthday',
  'register.email': 'E-mail',
  'register.email.required': 'Please enter your E-mail',
  'register.email.format_error': 'Incorrect E-mail format',
  'register.gender': 'Gender',
  'register.gender.required': 'Please select a gender',
  'register.city': 'City',
  'register.city.required': 'Please select a city',
  'register.job': 'Occupation',
  'register.job.required': 'Please select an occupation',
  'register.eduction_level': 'Education level',
  'register.eduction_level.required': 'Please select an education level',
  'register.marriage': 'Marital status',
  'register.marriage.required': 'Please select a marital status',
  'register.habit': 'Interests',
  'register.habit.required': 'Please select an interest',
  'register.diet': 'Diet preference',
  'register.diet.required': 'Please select a diet preference',
  'register.agree': 'I agree',
  'register.term': 'Terms of Use',
  'register.privacy_policy': 'Privacy Policy',
  'register.account_verification': 'Account verification',
  'register.member_information': 'Member information',
  'register.complete': 'Complete Registration',
  'register.submit': 'Submit',
  'register.success': 'Registration successful',
  'register.success_with_mgm':
    'Registration successful! You will receive your exclusive registration reward within 5 minutes.',
  'register.country_code': 'Country code',
  'register.country_code.required': 'Please select a country code',
  'register.referral_code': 'Friend Referral Code',
  'register.prev_step': 'Previous',
  'register.next_step': 'Next',
} as Record<string, string>;
